module.exports = __webpack_public_path__ + "img/income.68997ae4.png";